/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Menu, useMantineColorScheme,
} from '@mantine/core';
import {
  DoorExit, MoonStars, SunHigh, Bell, Settings,
} from 'tabler-icons-react';
import { selectLoggedInStatus } from '../../redux/selectors';
import styles from './Layout1.module.css';
import { deleteCookie } from '../../utilities/cookiesSession';
import actions from '../../redux/actions';

const Header1 = () => {
  const loggedInUser = useSelector(selectLoggedInStatus);
  const [notificationCount] = useState(3);
  const dispatch = useDispatch();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  const updateStoreForLogout = () => dispatch({
    type: actions.SET_LOGGED_IN_STATUS,
    payload: {
      loggedIn: false,
    },
  });
  const logout = () => {
    updateStoreForLogout();
    deleteCookie('authToken');
  };

  // Function to get initials from name
  const getInitials = (fullName) => {
    if (!fullName) return '';

    const names = fullName.trim().split(' ');

    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }

    // Get first letter of first name and first letter of last name
    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  };

  return (
    <div className={`flex flex-row ${styles.headerContainer1} justify-between h-[65px] items-center border-b ${colorScheme === 'dark' && '!bg-[#26282C] !border-neutral-500'}`}>
      {/* Logo and Title */}
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-blue-500 rounded-xl flex items-center justify-center">
          <span className="text-white font-bold text-lg">O</span>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 dark:text-[#BEB9B9]">
          OTI Dashboard
        </h1>
      </div>
      {/* Right Side Icons */}
      <div className="flex items-center gap-2">
        <div onClick={() => toggleColorScheme()} className={styles.themeIcon}>
          {colorScheme === 'dark'
            ? (
              <SunHigh
                size={20}
                strokeWidth={2}
              // color="#bfb440"
              />
            )
            : (
              <MoonStars
                size={20}
                strokeWidth={2}
              // color="#495057"
              />
            )}
        </div>
        <div className="relative p-2">
          <Bell size={20} strokeWidth={2} />
          {notificationCount > 0 && (
            <span className="absolute -top-1 -right-0.5 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-lg flex items-center justify-center">
              {notificationCount}
            </span>
          )}
        </div>
        {/* Settings */}
        <div>
          <Settings size={20} strokeWidth={2} />
        </div>

        <Menu>
          <Menu.Target>
            <div className="flex items-center cursor-pointer">
              <div
                className="w-9 h-9 rounded-full bg-[#E8F3FF] text-[#2B7FFF] flex items-center justify-center text-lg font-semibold"
              >
                {getInitials(loggedInUser.name)}
              </div>
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              onClick={(e) => {
                e.stopPropagation();
                logout();
              }}
              color="red"
              icon={<DoorExit size={14} />}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>

    </div>
  );
};

export default Header1;
